// @flow

import { sagaRepeatedlyFetchCurrentUserInitially } from './fetchCurrentUser'
import { sagaRepeatedlyFetchInitialData } from './fetchInitialData'

import {
  sagaRepeatedlyFetchPollsIntoStore,
  sagaRepeatedlyFetchFeaturedPollsIntoStore,
} from './fetchPolls'
import { sagaRepeatedlyFetchPollIntoStore } from './fetchPoll'
import { sagaRepeatedlyFetchIconsIntoStore } from './fetchIcons'

import { sagaRepeatedlyFetchAutomatedPollsIntoStore } from './fetchAutomatedPolls'

import { sagaRepeatedlyfetchAutomationArticles } from './automation/fetchAutomationArticles'
import { sagaRepeatedlyFetchBlacklistIntoStore } from './automation/fetchBlacklist'
import { sagaRepeatedlyAddBlacklistUrl } from './automation/addBlacklist'
import { sagaRepeatedlyDeleteBlacklistUrl } from './automation/deleteBlacklist'
import { sagaRepeatedlyfetchAnalyticsImpressions } from './analytics/fetchImpressions'

import { sagaRepeatedlyLoginButtonClick } from './login'
import {
  sagaRepeatedlyLogoutButtonClick,
  sagaRepeatedlyLogoutUnauthorizedUser,
} from './logout'
import { sagaRepeatedlyPollBuilderSaveButtonClick } from './savePoll'
import { sagaRepeatedlyPollBuilderDeleteButtonClick } from './deletePoll'

import fetchCustomerVerticalsSaga from './fetchCustomerVerticals'

import { setFeaturePollSaga } from './featurePoll'
import { setAutomatedPollSaga } from './automatedPoll'
import { refreshOnCustomerSelection } from './refreshOnCustomerSelection'
import { iconCreationSaga } from './icons/creation'

import { uploadRankingToolOptionImage } from '../stores/upload/sagas'
import { clearOnSearchChange, fetchOnSearchChange } from '../stores/ui/search'
import { fetchTagsSaga } from './fetchTags'
import { fetchCustomersSaga } from '../stores/customersStore'
import { saveCopiedPollSaga } from '../stores/polls/copyPoll'

import ReportSaga from './report/fetchBrandReports'

import PublishersReportSaga from './report/fetchPublishersReports'
import PublishersRevenueSaga from './report/fetchPublishersRevenue'
import { all } from 'redux-saga/effects'

export default function* rootSaga(): * {
  yield all([
    sagaRepeatedlyFetchCurrentUserInitially(),
    sagaRepeatedlyFetchInitialData(),
    sagaRepeatedlyFetchPollsIntoStore(),
    sagaRepeatedlyFetchPollIntoStore(),
    sagaRepeatedlyFetchIconsIntoStore(),

    sagaRepeatedlyfetchAutomationArticles(),
    sagaRepeatedlyFetchBlacklistIntoStore(),
    sagaRepeatedlyAddBlacklistUrl(),
    sagaRepeatedlyDeleteBlacklistUrl(),

    sagaRepeatedlyfetchAnalyticsImpressions(),

    sagaRepeatedlyLoginButtonClick(),
    sagaRepeatedlyLogoutButtonClick(),
    sagaRepeatedlyLogoutUnauthorizedUser(),
    sagaRepeatedlyPollBuilderSaveButtonClick(),
    sagaRepeatedlyPollBuilderDeleteButtonClick(),

    sagaRepeatedlyFetchFeaturedPollsIntoStore(),
    sagaRepeatedlyFetchAutomatedPollsIntoStore(),

    setFeaturePollSaga(),
    refreshOnCustomerSelection(),
    setAutomatedPollSaga(),

    iconCreationSaga(),
    uploadRankingToolOptionImage(),

    clearOnSearchChange(),
    fetchOnSearchChange(),

    fetchTagsSaga(),
    fetchCustomersSaga(),
    saveCopiedPollSaga(),
    ReportSaga(),
    PublishersReportSaga(),
    PublishersRevenueSaga(),

    fetchCustomerVerticalsSaga(),
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/index.js